import axios from 'axios';

export function registerNetOperatorCheck() {
    localStorage.removeItem("netOperatorData"); 

    const button = document.getElementById("button-net-check");
    if (!button) return;

    const postalInput = document.getElementById("k-postal-check-postcode");
    const houseNumberInput = document.getElementById("k-postal-check-nr");
    const extensionInput = document.getElementById("k-postal-check-extension");
    const resultContainer = document.querySelector(".net-operator-results-container");

    postalInput.oninput = () => {
        postalInput.setAttribute('inputmode', zipCodeInputType(postalInput));
    };

    function zipCodeInputType(postalCodeInput) {
        return postalCodeInput.value.length > 3 ? 'text' : 'numeric';
    }

    resultContainer.innerHTML = "";

    function submitForm() {
        if (!checkForm()) {
            return;
        }

        const postalCode = postalInput.value.trim().replace(/\s+/g, "").toUpperCase();
        const houseNumber = houseNumberInput.value.trim();
        const extension = extensionInput.value.trim();

        fetchNetOperator(postalCode, houseNumber, extension);
    }

    button.addEventListener("click", function (event) {
        event.preventDefault();
        submitForm();
    });

    [postalInput, houseNumberInput, extensionInput].forEach(input => {
        input.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                event.preventDefault(); 
                submitForm();
            }
        });
    });

    function checkForm() {
        let valid = true;

        const postalCode = postalInput.value.trim().replace(/\s+/g, "").toUpperCase();
        const houseNumber = houseNumberInput.value.trim();

        clearFieldError("postcode");
        clearFieldError("number-extension");

        const postalCodeRegex = /^[1-9][0-9]{3}[A-Z]{2}$/;
        if (!postalCodeRegex.test(postalCode)) {
            setFieldError("postcode", "Vul een geldige postcode in. Bijvoorbeeld 1234AB");
            valid = false;
        }

        const houseNumberRegex = /^[0-9]+$/;
        if (!houseNumberRegex.test(houseNumber)) {
            setFieldError("number-extension", "Vul een geldig huisnummer in. Bijvoorbeeld 1");
            valid = false;
        }

        return valid;
    }

    function fetchNetOperator(postalCode, houseNumber, extension) {
        button.classList.add("loading");

        let apiUrl = `https://api-energie.keuze.nl/v1/postcode-check/yZv4mJs9qTfWcQz6-554/${postalCode}/${houseNumber}`;
        if (extension) {
            apiUrl += `-${extension}`;
        }

        axios.get(apiUrl)
            .then(response => {
                if (response.data && response.data.location) {
                    updateUI(response.data.location);
                } else {
                    console.warn("Geen resultaten gevonden:", response);
                    resultContainer.innerHTML = "<p>Geen resultaten gevonden.</p>";
                }
            })
            .catch(error => {
                console.error("Error fetching data", error);
                resultContainer.innerHTML = "<p>Er is een fout opgetreden bij het ophalen van gegevens.</p>";
            })
            .finally(() => {
                button.classList.remove("loading");
            });
    }

    function updateUI(data) {
        const formContainer = document.getElementById("energy-form");
        formContainer.classList.add("hidden");

        setTimeout(() => {
            formContainer.style.display = "none";
        }, 400);

        if (data.address_found !== false) {
            let hasGas = "";
            let totalCostsNetwork = "";

            const electricityCostsFormatted = parseFloat(data.electricity_network_costs).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            if (data.gas_network_provider) {
                const totalCosts = parseFloat(data.electricity_network_costs) + parseFloat(data.gas_network_costs);
        
                const gasCostsFormatted = parseFloat(data.gas_network_costs).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                const totalCostsFormatted = totalCosts.toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                hasGas = `
                    <div class="results gas">
                        <span>Gas</span>
                        <div class="result">Netbeheerder<span class="provider">${data.gas_network_provider}</span></div>
                        <div class="result">Kosten per jaar<span>€ ${gasCostsFormatted}</span></div>
                    </div>
                `;

                totalCostsNetwork = `
                    <div class="total-row">
                        <div class="results">
                            <span>Totaal</span>
                            <div class="result">Totaal per jaar<span>€ ${totalCostsFormatted}</span></div>
                        </div>
                    </div>
                `;
            }

            resultContainer.innerHTML = `
                <div class="net-operator-results">
                    <div class="title">De netbeheerkosten op jouw adres:</div>
                    <div class="adress-row">
                        <span>${data.street} ${data.number}${data.numberExtension ? " " + data.numberExtension : ""}, ${data.postCode} ${data.city}</span>
                        <a href="#" id="edit-address">Wijzig adres</a>
                    </div>
                    <div class="results-row">
                        <div class="results electricity">
                            <span>Stroom</span>
                            <div class="result">Netbeheerder<span class="provider">${data.electricity_network_provider}</span></div>
                            <div class="result">Kosten per jaar<span>€ ${electricityCostsFormatted}</span></div>
                        </div>
                        ${hasGas}
                    </div>
                    ${totalCostsNetwork}
                </div>
            `; 
        } else {
            resultContainer.innerHTML = `
                <div class="net-operator-results">
                    <div class="adress-row">
                        <div>
                            <span class="title">We konden je adres helaas niet vinden</span>
                            <span>Check of je het juiste adres bij de hand hebt. Misschien ben je een toevoeging vergeten? Pas je adres aan en probeer het opnieuw.</span>
                        </div>
                        <a href="#" id="edit-address">Wijzig adres</a>
                    </div>
                </div>
            `;
        }

        setTimeout(() => {
            resultContainer.classList.add("visible");
        }, 20);

        document.getElementById("edit-address").addEventListener("click", function (e) {
            e.preventDefault();
            resultContainer.classList.remove("visible");

            setTimeout(() => {
                resultContainer.innerHTML = "";
                formContainer.style.display = "grid";
                setTimeout(() => {
                    formContainer.classList.remove("hidden");
                }, 10);
            }, 400);
        });
    }

    function setFieldError(field, message) {
        const errorField = document.querySelector(`[data-error-field='${field}']`);
        if (errorField) {
            errorField.innerHTML = message;
            errorField.classList.add('visible');
        }
    }

    function clearFieldError(field) {
        const errorField = document.querySelector(`[data-error-field='${field}']`);
        if (errorField) {
            errorField.innerHTML = '';
            errorField.classList.remove('visible');
        }
    }
}
